"use client";

import { QueryCache, QueryClient, QueryClientProvider, isServer } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import * as React from "react";
import { ReactQueryStreamedHydration } from "@tanstack/react-query-next-experimental";
import { GenericError } from "@/04-drivers/dal/error";
function makeQueryClient() {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: error => {
        if (!(error instanceof GenericError)) {
          return;
        }
        if (error.name === "UNAUTHORIZED_ERROR" || error.name === "OUT_OF_LIMIT_ERROR") {}
      }
    }),
    defaultOptions: {
      queries: {
        retry: 0,
        staleTime: Infinity
      }
    }
  });
}
let browserQueryClient: QueryClient | undefined = undefined;
function getQueryClient() {
  if (isServer) {
    return makeQueryClient();
  } else {
    if (!browserQueryClient) browserQueryClient = makeQueryClient();
    return browserQueryClient;
  }
}
export function QueryProvider(props: {
  children: React.ReactNode;
}) {
  const queryClient = getQueryClient();
  return <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-component="QueryProvider" data-sentry-source-file="QueryProvider.tsx">
      <ReactQueryStreamedHydration data-sentry-element="ReactQueryStreamedHydration" data-sentry-source-file="QueryProvider.tsx">
        {props.children}
      </ReactQueryStreamedHydration>
      <ReactQueryDevtools initialIsOpen={false} data-sentry-element="ReactQueryDevtools" data-sentry-source-file="QueryProvider.tsx" />
    </QueryClientProvider>;
}